import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as artifactActions from '~/artifact/actions';
import ArtifactViewMainContentVulnerableMethodsComponentVersions from '~/artifact/containers/ArtifactViewMainContentVulnerableMethodsComponentVersions';
import ArtifactViewMainContentSignaturesComponentVersionDetailsVulnerableMethods from '~/artifact/containers/ArtifactViewMainContentSignaturesComponentVersionDetailsVulnerableMethods';
type ArtifactViewMainContentVulnerableMethodsProps = {
  actions: object;
  artifactState: object;
};
class ArtifactViewMainContentVulnerableMethods extends React.Component<
  ArtifactViewMainContentVulnerableMethodsProps,
  {}
> {
  render() {
    return (
      <div className="grid grid--full ph">
        <div className="grid__item col-1-1">
          <div className="grid">
            <div className="grid__item col-1-4">
              <ArtifactViewMainContentVulnerableMethodsComponentVersions />
            </div>
            <div className="grid__item col-3-4 bo-l--1 border-color--muted">
              <ArtifactViewMainContentSignaturesComponentVersionDetailsVulnerableMethods />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentVulnerableMethods);
